import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ManagerSidebarDetail = (props) => {
    const { t } = useTranslation()
    // Menü başlıkları (öğretmenler, sınıflar, öğrenciler...) varsayılan olarak açık gelir.
    const [open, setOpen] = useState({ schools: true, teachers: true, class: true, student: true });
    const toggleSection = (id) => {
        setOpen((prev) => ({ ...prev, [id]: !prev[id] }));
    };
    const { user } = useAuth();
    return (
        <ul class="list-unstyled components ">
            <li id="school">
                <div>
                    <a href="#" className="dropdown-toggle" aria-controls="schools" aria-expanded={!!open.schools} onClick={(e) => { e.preventDefault(); toggleSection("schools"); }}>
                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>

                        <b className="forsidebar">&nbsp;{t('school')}</b>

                    </a>
                    <ul className={`collapse list-unstyled ${open.schools ? "show" : ""}`} id="schools">
                        <li>
                            <a href={"/school/editschool/" + user.userDetail.schoolId}>
                                <b className="forsidebar">
                                    {t('editSchool')}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <br />
            <li id="schoolteacher">
                <div>
                    <a href="#" className="dropdown-toggle" aria-controls="teachers" aria-expanded={!!open.teachers} onClick={(e) => { e.preventDefault(); toggleSection("teachers"); }}>
                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>

                        <b className="forsidebar">&nbsp;{t('teachers')}</b>

                    </a>
                    <ul className={`collapse list-unstyled ${open.teachers ? "show" : ""}`} id="teachers">


                        <li>
                            <a href="/school/teachercreate">
                                <b className="forsidebar">
                                    {t('createteacher')}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/school/teacherlist">
                                <b className="forsidebar">
                                    {t('teachersList')}
                                </b>
                            </a>
                        </li>
                    </ul>


                </div>

            </li>
            <br />
            <li id="classesteacher">
                <div>
                    <a href="#" className="dropdown-toggle" aria-controls="class" aria-expanded={!!open.class} onClick={(e) => { e.preventDefault(); toggleSection("class"); }}>
                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>
                        <b className="forsidebar">
                            &nbsp;
                            {t("classes")}
                        </b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.class ? "show" : ""}`} id="class">
                        <li>
                            <a href="/school/classlist">
                                <b><FontAwesomeIcon icon="fas fa-user-friends" /></b>
                                <b className="forsidebar">
                                    {t("classlist")}
                                </b>
                            </a>
                        </li>

                        <li>
                            <a href="/school/createclass">
                                <b>
                                    <FontAwesomeIcon icon="fas fa-user" />
                                </b>
                                <b className="forsidebar">
                                    {t("createclass")}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <br />
            <li id="studentsteacher">
                <div>
                    <a href="#" className="dropdown-toggle" aria-controls="student" aria-expanded={!!open.student} onClick={(e) => { e.preventDefault(); toggleSection("student"); }}>
                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>
                        <b className="forsidebar">
                            &nbsp;
                            {t("students")}
                        </b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.student ? "show" : ""}`} id="student">
                        <li>
                            <a href="/school/studentcreate">
                                <b className="forsidebar">
                                    {t("createstudent")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/school/studentlist">
                                <b className="forsidebar">
                                    {t("studentList")}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>

        </ul>
    );
};

export default ManagerSidebarDetail;